class VariantSelector extends HTMLElement {
  constructor() {
    super();

    this.initEvent = new Event('initialized');
    this.images = [];
    this.initVariantExtraDims();
    if (this.dataset.productGroup) {
      this.fetchProductGroup().then((product) => {
        this._product = product;
        this.initProductVariantSelector(product);
        this.updateProductJson(product);
        this.removeAttribute("data-loading");
        this.updateVariantDims();
        initVariantOptionsBreakdown();
        setTimeout(() => {
          this.addEventListener('change', this.onVariantChange.bind(this));

          if(typeof WSAIO != "undefined" && typeof WSAIO.productDiscount === "function") {
            this.updateOptions();
            this.updateMasterId();
            const productHandle = document.querySelector('.prod') ? document.querySelector('.prod').getAttribute('product_handle') : null;
            if(productHandle) {
              const prod = {
                id: this.currentVariant.product_id,
                available: true,
                handle: productHandle
              };
              // WSAIO.variantChange({
              //   id: this.currentVariant.id,
              //   price: this.currentVariant.price,
              //   sku: null,
              //   compare_at_price: this.currentVariant.compare_at_price,
              // }, '.prod', {
              //   id: this.currentVariant.product_id,
              //   available: true,
              //   handle: productHandle
              // });
              // WSAIO.variantChange(current_product2.variants[_indx],'.prod',current_product2);
              WSAIO.productDiscount({
                template: 'product',
                product_id: prod.id,
                product_handle: prod.handle,
                variant_id: this.currentVariant.id,
                variant_sku: document.querySelector('.prod').getAttribute('product_variant_sku'),
                variant_price: this.currentVariant.price,
                variant_compare_at_price: this.currentVariant.compare_at_price
              });
            }
          }
          const productForm = this.closest('product-form');
          productForm.querySelector('form [name="id"]').dispatchEvent(new Event('change'));

          this.dispatchEvent(this.initEvent);
        }, 100);
      })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          //submitButton.classList.remove('loading');
          //submitButton.removeAttribute('disabled');
        });;
      return;
    } else {
      initVariantOptionsBreakdown();
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.dispatchEvent(this.initEvent);
    }
  }

  onVariantChange(e) {
    if(e.target.closest('.line-item-property')) return;

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantDims();
    //this.updatePickupAvailability();

    document.querySelectorAll('.option-suggestion').forEach(optSgt => {
      optSgt.innerHTML = '';
    });

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      try{
        this.suggestAvailableOptions();
      } catch(err) {}
      
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      const inputChangeEvent = new CustomEvent('onInputChange', { detail: { currentVariant: this.currentVariant }, bubbles: true, composed: true });
      const stickyCart = document.querySelector("sticky-cart-banner");
      stickyCart?.dispatchEvent(inputChangeEvent);
    }
  }

  suggestAvailableOptions() {
    const optionIndex = 0;
    const projectedOptionIndex = 1;
    const projectedVariantsOptions = [];
    const possibleVariants = this.variantData.filter(variant => {
      return this.options[optionIndex] == variant.options[optionIndex]
    });

    possibleVariants.forEach(pv => {
      !projectedVariantsOptions.includes(pv.options[projectedOptionIndex]) 
        && projectedVariantsOptions.push(pv.options[projectedOptionIndex]);
    })

    if(projectedVariantsOptions.length) {
      const projectedOptionEle = document.querySelector(`variant-option[data-option-index="option-${projectedOptionIndex}"]`);
      const projectedSubOptionsEles = projectedOptionEle.querySelectorAll('variant-sub-option');
      let suggestionMesssage = '*In the height/width selected we only offer the {options}';
      let hasSuggestion = false;
      if(projectedSubOptionsEles && projectedSubOptionsEles.length) {
        const uniqueProjectedSubOptions = {};
        projectedVariantsOptions.forEach((pvo) => {
          const projectedSubOptions = pvo.split('|').map(o => o.trim());
          
          projectedSubOptions.forEach((pso, index) => {
            if(!uniqueProjectedSubOptions[`sub_opt_${index}`]) {
              uniqueProjectedSubOptions[`sub_opt_${index}`] = []
            }
            uniqueProjectedSubOptions[`sub_opt_${index}`].push(pso)
          })
        });
        projectedSubOptionsEles.forEach((optEle, index) => {
          const optSelectors = optEle.querySelectorAll('.variant-option__radios .variant-option__radio');
          // const optSelectedSelector = optEle.querySelector('.variant-option__radios .variant-option__radio input[type="radio"]:checked');
          if(optSelectors.length > 1) {
            const optLabel = optEle.querySelector('.variant-option__name').textContent;
            suggestionMesssage = suggestionMesssage.replace(
              '{options}', 
              `<strong>${optLabel}</strong> to <strong>${[...new Set(uniqueProjectedSubOptions[`sub_opt_${index}`])].join(' or ')}</strong>`
            )
            hasSuggestion = true;
          }
        });
        
        projectedOptionEle.querySelector('.option-suggestion').innerHTML = suggestionMesssage;
      } else {
        const optSelectors = projectedOptionEle.querySelectorAll('.variant-option__radios .variant-option__radio');
        if(optSelectors.length > 1) {
          const optLabel = projectedOptionEle.querySelector('.variant-option__name').textContent;
          suggestionMesssage = suggestionMesssage.replace(
            '{options}', 
            `<strong>${optLabel}</strong> to <strong>${[...new Set(projectedVariantsOptions)].join(', ')}</strong>`
          );
          hasSuggestion = true;
        }
      }
      if(hasSuggestion) {
        projectedOptionEle.querySelector('.option-suggestion').innerHTML = suggestionMesssage;
      }
    }
  }

  /**
   * Update selected variant options `options` based on selected values
   */
  updateOptions() {
    const optionSelectors = this.querySelectorAll('variant-option:not(.property)');
    this.options = Array.from(optionSelectors, (selector) => {
      let optValue = "";
      const subOptions = selector.querySelectorAll('variant-sub-option:not(.property)');
      if (subOptions && subOptions.length) {
        for (let i = 0; i < subOptions.length; ++i) {
          optValue += optValue.length ? " | " : "";
          optValue += this.getOptionSelectorValue(subOptions[i]);
        }
      } else {
        optValue = this.getOptionSelectorValue(selector);
      }
      return optValue;
    });
  }

  /**
   * Retrieve value of selected option
   * @param {*} selector 
   * @returns 
   */
  getOptionSelectorValue(selector) {
    let optValue = null;
    if (selector.querySelector('.variant-option__select select')) {
      optValue = selector.querySelector('.variant-option__select select').value;
    } else {
      optValue = selector.querySelector('.variant-option__radios .variant-option__radio input[type="radio"]:checked').value;
    }

    return optValue;
  }

  /**
   * Update master variant id
   */
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      const isFound = !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
      return isFound;
    });

    if(this.currentVariant) {
      const productForm = this.closest('product-form');

      const var_map_ele = document.querySelector('#var_map');
      if (var_map_ele) {
        const var_map = document.querySelector('#var_map').innerHTML;

        if (var_map && var_map.length) {
          const variantToHandleMap = JSON.parse(var_map);
          
          let currentProductHandle = null;
          for (let [handle, variantIds] of Object.entries(variantToHandleMap)) {
            if (variantIds.includes(this.currentVariant.id)) {
              currentProductHandle = handle;
            }
          }

          if (currentProductHandle) {
            const priceElemenmtSelector = document.querySelector('.prod')
            priceElemenmtSelector.setAttribute("product_handle", currentProductHandle);
            priceElemenmtSelector.setAttribute("handle", currentProductHandle);

            priceElemenmtSelector.classList.forEach(function (cEle) {
              if (cEle.includes('wsaio-pid-')) {
                priceElemenmtSelector.classList.remove(cEle);
              }
            });
            priceElemenmtSelector.classList.add('wsaio-pid-' + this.currentVariant.product_id);
            priceElemenmtSelector.setAttribute('product_id', this.currentVariant.product_id);
          }
        }
      }

      productForm.querySelector('form [name="id"]').value = this.currentVariant.id;
    }
  }

  updateMedia() {
    if(!this.currentVariant) return;
    if(!this.images && !this?.currentVariant?.featured_image) return;

    let image = null;
    
    if(this?.currentVariant?.featured_image) {
      image = this.currentVariant.featured_image;
    } else {
      image = this?.images?.find(i => i.product_id === this.currentVariant.product_id);
    }
    
    if(!image || !image?.src?.length) return;

    const sliderComponent = document.querySelector('slider-component');
    const firstSlide = sliderComponent.querySelector('li.product-media__item');

    if(firstSlide) {
      const newImage = image.src.replace('https:', '');
      firstSlide.setAttribute('data-src', newImage);
      const firstSlideImage = firstSlide.querySelector('img');

      const imageParts = newImage.split('.');
      const ext = imageParts.pop();
      const imageSrcWithoutExt = imageParts.join('.') + '_{width}';
      const imageSrcSizePlaceholder = imageSrcWithoutExt + '.' + ext;
      const image_widths = [288, 576, 1100, 1400, 1800];
      const image_srcset = image_widths.map(w => {
        return imageSrcSizePlaceholder.replace('{width}', `${w}x`) + ` ${w}w`
      });

      if(firstSlideImage) {
        firstSlideImage.setAttribute('srcset', image_srcset.join(', '))
      }
    }

    // if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    // const newMedia = document.querySelector(
    //   `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    // );
    // if (!newMedia) return;
    // const parent = newMedia.parentElement;
    // parent.prepend(newMedia);
    // window.setTimeout(() => { parent.scroll(0, 0) });
  }

  /**
   * Update url for selected product/variant
   * @returns 
   */
  updateURL() {
    if (!this.currentVariant) return;

    if (this.dataset.productGroup) {
      const child = this._product.children.find(child => child.id === this.currentVariant.product_id);
      if (child)
        this.dataset.url = `/products/${child.handle}`;
    }

    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  /**
   * Update hidden variant id input
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * Render product infor based on selected product variant
   */
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!(this.currentVariant && this.currentVariant.available), window.variantStrings.soldOut);

        // image
        // console.log(html.querySelector('slider-component li.product-media__item'));

        $('.affirm-as-low-as').attr('data-amount', this.currentVariant.price);
        affirm.ui.refresh();
      });
  }

  /**
   * Toggle add to cart button
   * @param {*} disable 
   * @param {*} text 
   * @param {*} modifyClass 
   * @returns 
   */
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }


  /**
   * Set unavailable
   * @returns 
   */
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  /**
   * Get variant data
   * @returns 
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('#ProductVariantsJson[type="application/json"]').textContent);
    return this.variantData;
  }

  getVariantsBreakdownData() {
    const variantBreakdown = this.querySelector('#ProductVariantsBreakdownJson[type="application/json"]');
    this.variantsBreakdownData = variantBreakdown && variantBreakdown.textContent.length ? ( this.variantsBreakdownData || JSON.parse(variantBreakdown.textContent) ) : null;
    return this.variantsBreakdownData;
  }

  // Product Group related functionality
  fetchProductGroup() {
    return fetch(`https://semi-exact-pg.herokuapp.com/api/product-group/${this.dataset.productGroup}/variants?minify=1`)
      .then((response) => response.json());
  }

  initProductVariantSelector(product) {
    let current_variant = null;
    if (this.dataset.currentVariantId) {
      current_variant = product.variants.find(variant => variant.id == this.dataset.currentVariantId)
    }
    
    const variantsBreakdown = this.getVariantsBreakdownData();

    let isColor = false;
    product.options.forEach((option, index) => {
      const option_name_lc = option.name.toLowerCase();
      const current_selected_option_value = current_variant ? current_variant.options[index] : '';
      let variantOptionsHTML = "";
      if (option.name.indexOf(' | ') !== -1) {
        const current_option_value = current_selected_option_value.length ? current_selected_option_value.split(' | ') : '';
        // Sub Options
        const optGroup = Array.from(option.name.split(' | '), (option_name, index) => {
          return {
            name: option_name,
            selected_value: current_option_value[index],
            values: [],
            id: `option-${Shopify.handleize(option.name)}-${1 + index}`
          }
        });
        let splitValues = null;
        for (let i = 0; i < option.values.length; i++) {
          splitValues = option.values[i].split(' | ');
          for (let j = 0; j < splitValues.length; j++) {
            if (typeof optGroup[j] !== 'undefined' && !optGroup[j].values.includes(splitValues[j])) {
              optGroup[j].values.push(splitValues[j].trim());
            }
          }
        }

        // Use these Sub Options 'optGroup'
        let optionHTML = optGroup.map(({ name, selected_value, values, id }) => {
          return `<variant-sub-option>
            <div class="variant-option__sub-option">
              ${this.generateSingleSubOption({
              option_name: name,
              selected_option_value: selected_value,
              option_values: values,
              id
            })}
            </div>
          </variant-sub-option>`;
        }).join("");
        optionHTML += this.generateLengthOption();
        variantOptionsHTML += `<div class="variant-option__sub-options ${optionHTML.includes('variant-option__radios') ? 'variant-option__sub-options--1fr' : ''}">${optionHTML}</div>`;
      } else {
        isColor = (option_name_lc.includes("color") || option_name_lc.includes("colour") || option_name_lc.includes("finish")) && !option_name_lc.includes("wood");
        const option_obj = {
          option_name: option.name,
          selected_option_value: current_selected_option_value,
          option_values: option.values,
          id: `option-${Shopify.handleize(option.name)}`
        };

        // variants breakdown
        let currentOptionBreakdownValues = [];
        const option_id = `option${index+1}`;
        const optionBreakdown = variantsBreakdown?.[option_id] || null;
        if(optionBreakdown) {
          if(optionBreakdown?.name && optionBreakdown?.values) {
            variantOptionsHTML += `
              <label class="variant-option__name">${ optionBreakdown.name }</label>
              <div class="breakdown-options">
                ${optionBreakdown.values.map((opt_breakdown, index) => {
                  let is_selected = false;
                  if(opt_breakdown.values.includes(current_selected_option_value)) {
                    is_selected = true;
                    currentOptionBreakdownValues = opt_breakdown.values;
                  }
                  return `
                    <div class="breakdown-option">
                      <input 
                        type="radio"
                        name="breakdown-${ option_id }"
                        id="breakdown-${ option_id }-${ index + 1 }"
                        value="${ opt_breakdown.name }"
                        ${is_selected ? 'checked' : ''}
                      />
                      <label for="breakdown-${ option_id }-${ index + 1 }">${ opt_breakdown.name }</label>
                      <script type="application/json" class="BreakdownOptionsValues">${ JSON.stringify(opt_breakdown.values) }</script>
                    </div>
                  `;
                }).join('')}
              </div>
            `;
          }
        }

        if (isColor || option_obj.option_values.length < 6 || optionBreakdown) {
          variantOptionsHTML += this.generateOptionRadios({
            ...option_obj,
            breakdown_values: currentOptionBreakdownValues,
          }, isColor);
        } else {
          variantOptionsHTML += this.generateOptionSelect(option_obj);
        }
      }

      variantOptionsHTML += '<div class="option-suggestion"></div>';
      if(option_name_lc.includes('width')) {
        variantOptionsHTML += `<top-or-bottom-width>
          <span id="calc-width-label">ASDF</span>
          <span id="calc-width"></span>
        </top-or-bottom-width>`;
      }
      this.querySelector(`variant-option[data-option-index="option-${index}"]`).innerHTML = variantOptionsHTML;

      const optionProps = this.addOptionProperties(index);
      //data-option-index="option-0"
    });

  }

  addOptionProperties(option_index) {
    const selectorAttr = `[data-option-index="option-${option_index}"]`;
    const variantOptionEle = this.querySelector(`${selectorAttr}`);
    let destination = variantOptionEle;
    if(variantOptionEle.querySelector('.variant-option__sub-options')) {
      destination = variantOptionEle.querySelector('.variant-option__sub-options');
    }
    let propertiesMarkup = '';
    if(!variantOptionEle) return;

    const productFormEle = this.closest('product-form');

    const propertiesRefs = productFormEle.querySelectorAll('.property-reference');
    propertiesRefs.forEach(propEle => {
      const placement = propEle.dataset.propertyPlacement;
      if(placement === selectorAttr) {
        const propValues = propEle?.dataset?.value;
        if(propValues) {
          const vals = JSON.parse(propValues);
          if(vals.length) {
            let propOptionStart = `<div class="property line-item-property" data-property="${propEle.dataset.propertyHandle}">`;
            let propOptionEnd = `</div>`;
            if(destination.querySelector('variant-sub-option')) {
              propOptionStart = `<variant-sub-option class="property line-item-property" data-property="${propEle.dataset.handle}"><div class="variant-option__sub-option">`;
              propOptionEnd = `</div></variant-sub-option>`;
            }

            propertiesMarkup += `
              ${propOptionStart}
              <label class="variant-option__name">${propEle.dataset.propertyLabel}</label>
              <div class="variant-option__select" data-option-label="${propEle.dataset.propertyLabel}">
                <select id="property-length">
                  ${vals.map(val => {
                    return `<option value='${val}'>${val}</option>`;
                  }).join('')}
                </select>
              </div>
              ${propOptionEnd}
            `;
          }
        }
      }
    });

    if(propertiesMarkup.length) {
      destination.insertAdjacentHTML('beforeend', propertiesMarkup);
    }
  }

  generateLengthOption() {
    const props = document.querySelectorAll('.property-ref');
    let propsMarkup = '';

    props.forEach((p) => {
      const { ref, propertyHandle, propertyLabel, value } = p.dataset;

      const values = value.split(',');
      propsMarkup += `<variant-sub-option class="property line-item-property" data-property="${propertyHandle}">
        <div class="variant-option__sub-option">
          <label class="variant-option__name">${propertyLabel}</label>
          <div class="variant-option__select" data-option-label="Length (in)">
            <select id="property-length">
              ${values.map(val => {
                return `<option value='${val}"'>${val}"</option>`;
              }).join('')}
            </select>
          </div>
        </div>
      </variant-sub-option>`;
    })
    
    return propsMarkup;
  }

  generateSingleSubOption(option) {
    const name_lc = option.option_name.toLowerCase();
    const isColor = (name_lc.includes("color") || name_lc.includes("colour") || name_lc.includes("finish") || name_lc.includes("kit style")) && !name_lc.includes("wood");
    const isRadio = option.option_values && option.option_values.length < 6;
    return isRadio || isColor ? this.generateOptionRadios(option, isColor) : this.generateOptionSelect(option);
  }

  generateOptionSelect({ option_name, option_values, id, selected_option_value }) {
    const dimensionsNouns = ['length', 'width', 'height', 'diameter', 'size', 'depth'];
    const optionNameLC = option_name.toLowerCase();
    const isDimension = dimensionsNouns.find(val => optionNameLC.includes(val));
    const values = isDimension === undefined ? option_values : option_values.sort(Shopify.sortAlphaNum);
    return `<label class="variant-option__name">${option_name}</label>
    <div class="variant-option__select" data-option-label="${option_name}">
      <select id="${id}" data-cso='${selected_option_value}'>
        ${values.map(value => {
      return `<option ${value == selected_option_value ? 'selected="selected"' : ''} value='${value.trim()}'>${value}</option>`;
    }).join('')}
      </select>
    </div>`;
  }

  generateOptionRadios({ option_name, option_values, id, selected_option_value, breakdown_values }, isColor = false) {
    const dimensionsNouns = ['length', 'width', 'height', 'diameter', 'size', 'depth'];
    const optionNameLC = option_name.toLowerCase();
    const isDimension = dimensionsNouns.find(val => optionNameLC.includes(val));
    const values = isDimension === undefined ? option_values : option_values.sort(Shopify.sortAlphaNum);
    
    return `<fieldset class="js product-form__input ${isColor ? 'product-form__input-color' : ''}">
      <legend class="${isColor ? 'visually-hidden' : ''} variant-option__name form__label">${option_name}</legend>
      <div class="variant-option__radios" data-option-label="${option_name}">
        ${this.generateOptionRadiosSelectors(option_name, values, selected_option_value, breakdown_values, isColor)}
      </div>
    </fieldset>`;
  }

  generateOptionRadiosSelectors(option_name, values, selected_option_value, breakdown_values, isColor) {
    let selectors = values.map((value, index) => {
      let labeledValue = value;
      if(option_name.includes('Size (H x W x L)')){
        labeledValue = value.replace(/\((h|w|l)\)/g, '');
      } 
      else if(option_name.includes("Wood Finish") && value.includes("Wood Finish: None")){
        labeledValue = value.replace("Wood Finish: None", 'None');
      }
      else if(option_name.includes("Wood Finish") && value.includes("Wood Finish: Coated")){
        labeledValue = value.replace("Wood Finish: Coated", 'Coated');
      }
      const value_dc = value.toLowerCase();
      let disabledOptions = [];
      if(isColor && this.dataset?.disabledColors && this.dataset?.disabledColors.length) {
        disabledOptions = this.dataset.disabledColors.toUpperCase().split('|');
      }

      let hide_option_selector = false;
      if(breakdown_values && breakdown_values.length > 0) {
        hide_option_selector = !breakdown_values.includes(value);
      }
      return `<div class="variant-option__radio ${hide_option_selector ? 'variant-option__radio--hidden' : ''} ${isColor ? 'variant-option__radio--color' : ''} ${disabledOptions.length && disabledOptions.includes(value.toUpperCase()) ? 'variant-option__radio--disabled' : ''}" data-opt-value="${value}">
            <input type="radio" id="${this.dataset.section}-${Shopify.handleize(option_name)}-${index}"
              name="${option_name}"
              value='${value}'
              form="product-form-${this.dataset.section}"
              ${value == selected_option_value ? 'checked' : ''}
              ${disabledOptions.length && disabledOptions.includes(value.toUpperCase()) ? 'disabled' : ''}
            >
            <label
              for="${this.dataset.section}-${Shopify.handleize(option_name)}-${index}"
              title='${value}'
              >${isColor ? `<span style="background-image: url('${this.getColorImageUrl(Shopify.handleize(value))}');"></span>` : ''}${labeledValue}</label>
          </div>`;
    }).join('');

    if(isColor && !option_name.toLowerCase().includes('wood') && (option_name.toLowerCase().includes('color') || option_name.toLowerCase().includes('finish'))) {
      const finishOptions = document.querySelector('#ProductFinishNamesJson');
      const finishDisabled = document.querySelector('#ProductFinishDisabledJson');
      const finishImages = document.querySelector('#ProductFinishImagesJson');
      if(finishOptions) {
        const finishOptionsObj = JSON.parse(finishOptions.innerHTML);
        const finishDisabledObj = JSON.parse(finishDisabled.innerHTML);
        const finishImagesObj = JSON.parse(finishImages.innerHTML);
        
        const finish = [];
        finishOptionsObj.forEach((f, index) => {
          finish.push({
            name: f,
            disabled: finishDisabledObj[index] === 'true',
            images: finishImagesObj[index]
          });
        });

        if(finish.length) {
          let already_checked = false;
          selectors += finish.map(({name, disabled, images}) => {
            let checked_radio = '';
            const finish_option_id = `finish-powder-coat-${Shopify.handleize(name)}`;
            const finish_image_url = this.getColorImageUrl(`${Shopify.handleize(name)}.jpg`);
            if(!already_checked && selected_option_value === 'Powder Coated' && !disabled) {
              already_checked = true;
              checked_radio = 'checked';
            }
            return `
              <div class="prop-finish-option ${disabled ? 'prop-finish-option--disabled': ''}">
                <input 
                  type="radio" 
                  id="${finish_option_id}" 
                  name="properties[Powder Coat]" 
                  value="${name}"
                  ${disabled ? 'disabled' : ''}
                  ${checked_radio}
                />
                <label for="${finish_option_id}"><span style="background-image: url('${finish_image_url}');"></span>${name}</label>
              </div>
            `;
  
          }).join('');
        }
      }
    }

    return selectors;
  }

  updateProductJson(product) {
    this.querySelector('#ProductVariantsJson[type="application/json"]').textContent = JSON.stringify(product.variants);
    this.images = product.images;
  }

  getColorImageUrl(color) {
    return window.variantStrings.colorMockFileUrl.replace('mock-image', color).split('?')[0];
  }

  // Variant Extra Dims
  initVariantExtraDims() {
    const variantExtraDim = document.querySelector('variant-dims');
    if (!variantExtraDim) return;
    const dimSrc = variantExtraDim.querySelector('.dim-src');
    if (!dimSrc) return;

    fetch(`${dimSrc.value}`)
      .then((response) => response.json())
      .then(data => {
        this.dimsData = data;
      }).catch(e => {
        this.dimsData = null;
      });
  }

  updateVariantDims() {
    const selectedOptionsEle = document.querySelectorAll('[data-option-label]');
    const selectedOptions = {};
    selectedOptionsEle.forEach(ele => {
      const lbl = ele.getAttribute('data-option-label').trim();//.replace('(in)','').replace('(IN)', '').replace('(In)', '').trim();
      if (ele.querySelector('select')) {
        selectedOptions[lbl] = ele.querySelector('select').value;
      } else {
        selectedOptions[lbl] = ele.querySelector('input[type="radio"]:checked').value;
      }
    });

    const excludeCols = ['id', 'Width at Top'];
    if (this.dimsData) {
      const foundDimension = this.dimsData.find(dim => {
        const isFound = Object.keys(dim).map(function (key) {
          const _dimVal = dim[key][dim[key].length - 1] == '"' ? dim[key] : dim[key] + '"';
          return excludeCols.includes(key) ? true : selectedOptions[key] === _dimVal;
        });
        return !isFound.includes(false);
      });

      const variantExtraDim = document.querySelector('variant-dims');
      if (foundDimension) {
        variantExtraDim.querySelector('.dim_measurement').innerHTML = foundDimension['Width at Top'];
        variantExtraDim.setAttribute('show', true);
      } else {
        variantExtraDim.removeAttribute('show');
      }

    }
    /*this.getVariantData().find((variant) => {
      const isFound = !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
      return isFound;
    });*/
  }

}

customElements.define('variant-selector', VariantSelector);

function initVariantOptionsBreakdown() {
  const breakdownOptions = document.querySelectorAll('.breakdown-options .breakdown-option');
  if(breakdownOptions) {
    breakdownOptions.forEach((breakdownOption) => {
      breakdownOption.addEventListener('click', () => {
        const valuesJsonString = breakdownOption.querySelector('.BreakdownOptionsValues');
        if(!valuesJsonString) return;

        const valuesJson = JSON.parse(valuesJsonString.innerHTML);
        const variantOptionEle = breakdownOption.closest('variant-option');
        const variantOptionRadios = variantOptionEle.querySelectorAll('.variant-option__radio');

        variantOptionRadios.forEach((radio) => {
          const radioInput = radio.querySelector('input[type="radio"]');
          if(!valuesJson.includes(radioInput.value)) {
            radio.classList.add('variant-option__radio--hidden');
          } else {
            radio.classList.remove('variant-option__radio--hidden');
          }
        });

        if(variantOptionEle) {
          const selectedRadioOption = variantOptionEle.querySelector('.variant-option__radios .variant-option__radio input[type="radio"]:checked');
          if(selectedRadioOption) {
            // selectedRadioOption.setAttribute('checked', false);
            selectedRadioOption.checked = false;
          }

          const visibleRadioOptions = variantOptionEle.querySelectorAll('.variant-option__radios .variant-option__radio:not(.variant-option__radio--hidden) input[type="radio"]');
          const radioInput = visibleRadioOptions[0];
          radioInput.checked = true;

          // variantOptionEle.querySelector('variant-selector').dispatchEvent(new Event('change'));
        }
      });
    });
  }
}
